// The shortlist's words: its subtitle, the message in place of the lines,
// and what is said of the played move. Pure: no React, no DOM.
import { formatScore, type Verdict } from './verdict.ts';
import type { Played, ShortlistState } from './search.ts';

/** The head's tooltip: whose score it is and how deep, once there is a position. */
export function subtitleOf(s: Pick<ShortlistState, 'fen' | 'sideToMove' | 'depth'>): string | undefined {
  return s.fen ? `scored for ${s.sideToMove}, who is to move${s.depth ? ` · depth ${s.depth}` : ''}` : undefined;
}

/** The depth shown beside the title, or nothing before the first update. */
export function depthLabel(depth: number): string {
  return depth ? `depth ${depth}` : '';
}

/** What shows in place of the lines, if anything. */
export function messageOf(s: Pick<ShortlistState, 'fen' | 'status' | 'error' | 'candidates'>): string | undefined {
  if (!s.fen) return 'No position to analyse.';
  if (s.status === 'failed') return `Engine failed: ${s.error}`;
  if (s.status === 'over') return 'The game is over here; there is nothing to play.';
  if (s.candidates.length === 0) return 'Searching…';
  return undefined;
}

/** The played move's score: its score, an ellipsis while it is being scored, or nothing. */
export function playedScoreText(played: Played, status: ShortlistState['status']): string {
  return played.score ? formatScore(played.score) : status === 'scoring' ? '…' : '';
}

/** What is said of the played move after "played in the game —". */
export function verdictWords(verdict: Verdict | undefined, status: ShortlistState['status']): string {
  if (verdict === 'best') return 'the engine’s choice';
  if (verdict === 'blunder') return 'a blunder';
  if (verdict === 'other') return 'a small loss';
  return status === 'done' ? 'not scored' : 'scoring…';
}
